import { useQuery } from "react-query";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { z } from "zod";

export const getAllProductReferenceApiKey = "productReferenceKey" as const;

type Options = {
    name?: string;
};

export const useGetAllProductReference = (options?: Options) => {
    const { name = null } = options || {};

    const queryResult = useQuery({
        queryKey: [getAllProductReferenceApiKey, name],
        queryFn: async () => {
            const url = "/api/product_references";
            const response = await sureApiCall.get(url, {
                params: { name, itemsPerPage: 50 },
            });
            return response;
        },
        select: (request) => {
            const productReference = request.data["hydra:member"];
            const data = zodParseWithLog(
                productReference,
                ProductReferenceSchema.array(),
                getAllProductReferenceApiKey,
            );
            return data;
        },
    });

    return {
        productsReference: queryResult.data,
        ...queryResult,
    };
};

export type ProductReference = {
    id: number;
    name: string;
};

const ProductReferenceSchema: z.ZodSchema<ProductReference> = z.object({
    id: z.number(),
    name: z.string(),
});
